import { can, type AuthorizedUser } from '@dma/auth';
import { AuthorizationError, ValidationError } from '@dma/shared';
import type { ArticleRepository } from '../../domain/repositories/ArticleRepository.interface';
import type { ArticleDto } from '../dto/ArticleDto';

export class GetArticleByIdUseCase {
  constructor(private readonly repository: ArticleRepository) {}

  public async execute(actingUser: AuthorizedUser | null, id: string): Promise<ArticleDto> {
    if (!can(actingUser, 'news:update')) {
      throw new AuthorizationError();
    }

    const article = await this.repository.getById(id);
    if (!article) {
      throw new ValidationError(`مطلبی با شناسه‌ی "${id}" یافت نشد.`);
    }
    return article.props;
  }
}
